import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bulk-edit-wrapper" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "row change-row" }
const _hoisted_4 = { class: "row-body" }
const _hoisted_5 = { class: "selectors" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "row dates-row" }
const _hoisted_8 = { class: "row-body" }
const _hoisted_9 = { class: "selectors date-range" }
const _hoisted_10 = { class: "start-date-wrapper" }
const _hoisted_11 = { class: "end-date-wrapper" }
const _hoisted_12 = { class: "notes" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "row change-row" }
const _hoisted_15 = { class: "kennels" }
const _hoisted_16 = { class: "dogs" }
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = { class: "total" }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = {
  key: 0,
  class: "available"
}
const _hoisted_21 = {
  key: 1,
  class: "available bad"
}
const _hoisted_22 = { class: "row dates-row" }
const _hoisted_23 = { class: "row-body" }
const _hoisted_24 = { class: "selectors date-range" }
const _hoisted_25 = { class: "start-date-wrapper" }
const _hoisted_26 = { class: "end-date-wrapper" }
const _hoisted_27 = { class: "notes" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 2,
  class: "loader-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "card-base",
      id: "bulk-edit",
      onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("button", {
        class: "button-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _cache[10] || (_cache[10] = [
        _createElementVNode("svg", {
          class: "icon close",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("path", {
            class: "fill",
            d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
          })
        ], -1)
      ])),
      _createElementVNode("div", _hoisted_2, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "header-3" }, "Bulk Edit", -1)),
        _createElementVNode("div", {
          class: "switch",
          onClick: $setup.toggleSwitch
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.useLegacyAction) = $event)),
            type: "checkbox"
          }, null, 512), [
            [_vModelCheckbox, $setup.useLegacyAction]
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "slider" }, null, -1))
        ])
      ]),
      ($setup.useLegacyAction)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "subheader" }, [
              _createElementVNode("span", null, "Choose the type of change and the dates below to update multiple dates at once")
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "row-header" }, "Change ", -1)),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("select", {
                    class: "add-remove-select",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.bulkAction) = $event))
                  }, _cache[13] || (_cache[13] = [
                    _createElementVNode("option", { value: 'Remove' }, "Remove ", -1),
                    _createElementVNode("option", { value: 'Add' }, "Add ", -1),
                    _createElementVNode("option", { value: 'Set Total' }, "Set Total", -1)
                  ]), 512), [
                    [_vModelSelect, $setup.bulkAction]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    class: "dog-amount",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.dogAmount) = $event)),
                    type: "number",
                    min: "1",
                    max: "10"
                  }, null, 512), [
                    [_vModelText, $setup.dogAmount]
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    class: _normalizeClass(["dog-size", $setup.selectedDogSize]),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.selectedDogSize) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.Dogspaces.Sizes, (size) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: size,
                        value: size
                      }, _toDisplayString($setup.Dogspaces.SizeTitle[size]), 9, _hoisted_6))
                    }), 128)),
                    _cache[14] || (_cache[14] = _createElementVNode("option", { value: 'all' }, "All Kennels", -1))
                  ], 2), [
                    [_vModelSelect, $setup.selectedDogSize]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "row-header" }, "Dates ", -1)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      class: "start-date",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.startDate) = $event)),
                      type: "date"
                    }, null, 512), [
                      [_vModelText, $setup.startDate]
                    ]),
                    _cache[16] || (_cache[16] = _createStaticVNode("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1438_8075)\"><path d=\"M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM9 14H7V12H9V14ZM13 14H11V12H13V14ZM17 14H15V12H17V14ZM9 18H7V16H9V18ZM13 18H11V16H13V18ZM17 18H15V16H17V18Z\" fill=\"#676772\"></path></g><defs><clipPath id=\"clip0_1438_8075\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>", 1))
                  ]),
                  _cache[18] || (_cache[18] = _createElementVNode("span", null, "-", -1)),
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      class: "end-date",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.endDate) = $event)),
                      type: "date"
                    }, null, 512), [
                      [_vModelText, $setup.endDate]
                    ]),
                    _cache[17] || (_cache[17] = _createStaticVNode("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1438_8075)\"><path d=\"M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM9 14H7V12H9V14ZM13 14H11V12H13V14ZM17 14H15V12H17V14ZM9 18H7V16H9V18ZM13 18H11V16H13V18ZM17 18H15V16H17V18Z\" fill=\"#676772\"></path></g><defs><clipPath id=\"clip0_1438_8075\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>", 1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, _toDisplayString($setup.daysBetween), 1)
              ])
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["is-available", {'available': $setup.slotIsAvailable === true, 'not-available': $setup.slotIsAvailable === false}])
            }, _toDisplayString($setup.isAvailableText), 3),
            (!$setup.kennelStore.defaultKennelMax)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Default kennel maxes not set. Please set the maximums on a single day first."))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "subheader" }, [
              _createElementVNode("span", null, "Choose the type of change and the dates below to update multiple dates at once")
            ], -1)),
            _createElementVNode("div", _hoisted_14, [
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "row-header" }, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.Dogspaces.Sizes, (size) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "size-container",
                  key: size
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(size)
                  }, _toDisplayString($setup.Dogspaces.SizeTitle[size]), 3),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => (($setup.givenCounts[size]) = $event),
                        type: "text"
                      }, null, 8, _hoisted_17), [
                        [_vModelText, $setup.givenCounts[size]]
                      ]),
                      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "label" }, "Dogs", -1))
                    ]),
                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "divider" }, "/", -1)),
                    _createElementVNode("div", _hoisted_18, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => (($setup.givenMax[size]) = $event),
                        type: "text"
                      }, null, 8, _hoisted_19), [
                        [_vModelText, $setup.givenMax[size]]
                      ]),
                      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "label" }, "Total", -1))
                    ])
                  ]),
                  ($setup.givenMax[size] - $setup.givenCounts[size] >= 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString($setup.givenMax[size] - $setup.givenCounts[size]) + " Available", 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_21, "Space Unavailable"))
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_22, [
              _cache[28] || (_cache[28] = _createElementVNode("div", { class: "row-header" }, "Dates ", -1)),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("input", {
                      class: "start-date",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.startDate) = $event)),
                      type: "date"
                    }, null, 512), [
                      [_vModelText, $setup.startDate]
                    ]),
                    _cache[25] || (_cache[25] = _createStaticVNode("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1438_8075)\"><path d=\"M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM9 14H7V12H9V14ZM13 14H11V12H13V14ZM17 14H15V12H17V14ZM9 18H7V16H9V18ZM13 18H11V16H13V18ZM17 18H15V16H17V18Z\" fill=\"#676772\"></path></g><defs><clipPath id=\"clip0_1438_8075\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>", 1))
                  ]),
                  _cache[27] || (_cache[27] = _createElementVNode("span", null, "-", -1)),
                  _createElementVNode("div", _hoisted_26, [
                    _withDirectives(_createElementVNode("input", {
                      class: "end-date",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.endDate) = $event)),
                      type: "date"
                    }, null, 512), [
                      [_vModelText, $setup.endDate]
                    ]),
                    _cache[26] || (_cache[26] = _createStaticVNode("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1438_8075)\"><path d=\"M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM9 14H7V12H9V14ZM13 14H11V12H13V14ZM17 14H15V12H17V14ZM9 18H7V16H9V18ZM13 18H11V16H13V18ZM17 18H15V16H17V18Z\" fill=\"#676772\"></path></g><defs><clipPath id=\"clip0_1438_8075\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>", 1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, _toDisplayString($setup.daysBetween), 1)
              ])
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["is-available", {'available': $setup.invalidSizes.length <= 0, 'not-available': $setup.invalidSizes.length > 0}])
            }, _toDisplayString($setup.isAvailableTextList), 3)
          ], 64)),
      _createElementVNode("button", {
        class: "book secondary outline",
        disabled: $setup.buttonDisabled,
        onClick: $setup.handleBook
      }, "Book", 8, _hoisted_28),
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createVNode($setup["Loader"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}